import React, { useState, useCallback, useEffect, useRef } from "react";

import { Container } from "./styles";

const LessonFile = (props) => {
  const [src, setSrc] = useState("");

  useEffect(() => {
    const formatedSrc = `https://${props.src.split("://").pop()}`;

    setSrc(formatedSrc);
  }, [props]);

  return (
    <Container>
      <a href={src}>{props.src}</a>
    </Container>
  );
};

export default LessonFile;
